import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'components/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons';

import './styles.scss';

export default function IncompleteDealFlag({ deal, onClick }) {
  if (!deal.incomplete) {
    return null;
  }

  let flag = (
    <div className="incomplete-deal-flag">
      <FontAwesomeIcon icon={faExclamation} />
    </div>
  );

  if (onClick) {
    flag = (
      <Tooltip
        content="Click to add missing information"
        overlayClassName="incomplete-deal-flag-tooltip"
        onClick={onClick}
      >
        {flag}
      </Tooltip>
    );
  }

  return flag;
}

IncompleteDealFlag.propTypes = {
  deal: PropTypes.shape({
    incomplete: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func,
};
